import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import CertificateIcon from "mdi-material-ui/CertificateOutline";
import { useEffect } from "react";
import { connect } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { bindActionCreators } from "redux";
import { certificadoProprio } from "../../../Course/common/redux/CourseActionCreators";

function CertificateButton({
  course,
  auth,
  certificates,
  getCertificate,
  CustomButton = null,
  ...props
}) {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    if (course) {
      getCertificate(
        course.matricula_conclusa,
        course.DISCIPLINAID,
        auth.token
      );
    }
  }, []);

  const handleClick = (event) => {
    event.stopPropagation();

    navigate(
      `/certificate/${course.matricula_conclusa}/${course.DISCIPLINAID}?from=${pathname}`
    );
  };

  return CustomButton ? (
    <CustomButton onClick={handleClick} />
  ) : (
    <Button
      sx={{
        cursor: "pointer",
        color: "default",
        border: "default",
        ":hover": {
          border: "default",
        },
      }}
      color="secondary"
      variant="outlined"
      onClick={handleClick}
    >
      <Typography marginRight="6px">Certificado</Typography>
      <CertificateIcon />
    </Button>
  );
}

const mapStateToProps = (state) => ({
  certificates: state.course.certificates,
  auth: state.auth,
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getCertificate: certificadoProprio,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(CertificateButton);
